import { BoxArrowInRight } from 'react-bootstrap-icons';

export function NotSignedIn(){
  return (
    <div className="flex items-center justify-center min-h-screen bg-blue-50 p-4 dark:bg-slate-700">
      <div className="bg-white dark:bg-slate-500 shadow-lg rounded-lg border-2 border-blue-300 p-8 max-w-md w-full text-center">
        <BoxArrowInRight className="mx-auto mb-4 text-blue-300" size={64} />
        <h2 className="text-2xl font-bold text-blue-700 mb-2 dark:text-blue-300">Please Sign In</h2>
        <h3 className='text-lg font-bold text-blue-700 dark:text-blue-300'>Use the button at the top-right corner.</h3>
        <p className="text-gray-600 dark:text-gray-100 mb-4">
          You must be logged in to access this page.
        </p>
      </div>
    </div>
  );
}
